import { render } from "./CreateSecondaryUser.vue?vue&type=template&id=75e2e5e6&scoped=true"
import script from "./CreateSecondaryUser.vue?vue&type=script&lang=js"
export * from "./CreateSecondaryUser.vue?vue&type=script&lang=js"

import "./CreateSecondaryUser.vue?vue&type=style&index=0&id=75e2e5e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e2e5e6"]])

export default __exports__